import { render } from "./searchLoader.vue?vue&type=template&id=5234eef2&scoped=true"
import script from "./searchLoader.vue?vue&type=script&lang=js"
export * from "./searchLoader.vue?vue&type=script&lang=js"

import "./searchLoader.vue?vue&type=style&index=0&id=5234eef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5234eef2"]])

export default __exports__